"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSearchCountSchema = void 0;
var zod_1 = require("zod");
exports.LocalSearchCountSchema = zod_1.z.object({
    count: zod_1.z.number(),
    text: zod_1.z.string(),
    enabled: zod_1.z.boolean(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
